import React from 'react';
import { Link } from 'react-router-dom';

const tagLinks = [
  { to: '/org/def', img: '/images/DEF.png', label: 'Dansk EL-Forbund' },
  { to: '/org/3f', img: '/images/3F_LOGO_Den_Offentlige_Gruppe.png', label: '3F' },
  { to: '/org/tl', img: '/images/TekniskLandsforbund.svg', label: 'Teknisk Landsforbund' },
  { to: '/org/dm', img: '/images/DanskMetal.png', label: 'Danske Metal' },
  { to: '/org/hk', img: '/images/HKKommunal.png', label: 'HK Kommunal' },
  { to: '/org/ds', img: '/images/DS.png', label: 'Dansk Socialrådgiverforening' },
  { to: '/org/sl', img: '/images/Socialpaedagogerne.svg', label: 'Socialpædagogerne' },
];

const FrontPage = () => (
  <div className="flex-1 p-6 flex flex-col items-center max-w-6xl mx-auto">
    {/* Welcome Section */}
    <div className="w-full mb-8">
      <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">Velkommen til Faglig Håndbog</h2>
      
      <div className="bg-blue-50 border-l-4 border-blue-400 p-6 mb-6">
        <p className="text-lg text-gray-700 mb-4">
          I Faglig Håndbog finder du alle de overenskomster, aftaler, love, vejledninger og andet, som er gældende for OAO’s forbunds medlemmer, der ansat i kommuner og regioner.
        </p>
        <p className="text-gray-600">
          Hvis du kun ønsker at søge på overenskomster mv. som er gældende for det pågældende forbund, kan du trykke på forbundets logo, hvorefter du viderestilles til dette forbunds Faglige Håndbog.
        </p>
      </div>
    </div>

    {/* Organization Logos */}
    <div className="flex flex-wrap gap-6 justify-center items-center">
      {tagLinks.map(link => (
        <Link
          key={link.to}
          to={link.to}
          className="flex flex-col items-center hover:scale-110 transition-transform"
        >
          <img src={link.img} alt={link.label} className="w-48 h-48 object-contain mb-2" />
        </Link>
      ))}
    </div>
  </div>
);

export default FrontPage;